<template>
  <div class="animated_class">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">Edit Vouchers</div>
      <router-link class="btn-blue" to="/vouchers/get-vouchers-v2"
        >{{ $t("voucher") }} {{ $tc("list") }}</router-link
      >
    </div>

    <div class="white-wrapper">
      <div class="new-border rounded-10 p-3 mb-4 back">
        <div class="row mb-3">
          <div class="col-lg-3 col-12">
            <div class="input-material">
              <input
                v-model="voucher_code"
                v-validate="{ required: 'required' }"
                name="voucher_code"
                id="voucher_code"
                placeholder="."
                type="text"
              />
              <label>Code</label>
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('voucher_code')">{{
                errors.first("voucher_code")
              }}</span>
            </p>
          </div>
          <div class="col-lg-3 col-12">
            <div class="input-material">
              <input
                v-model="voucher_name"
                v-validate="{ required: 'required' }"
                name="voucher_name"
                id="voucher_name"
                placeholder="."
                type="text"
              />
              <label>Voucher Name</label>
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('voucher_name')">{{
                errors.first("voucher_name")
              }}</span>
            </p>
          </div>
          <div class="col-lg-3 col-12">
            <div class="input-material">
              <input
                v-model="voucher_receipt_print"
                name="voucher_receipt_print"
                id="voucher_receipt_print"
                placeholder="."
                type="text"
              />
              <label>Receipt Inprint</label>
            </div>
          </div>
          <div class="col-lg-3 col-12 align-self-center">
            <div class="d-flex align-items-center justify-content-center">
              <b-form-checkbox
                class="ml-3 j-checkbox pb-0"
                v-model="voucher_is_active"
                unchecked-value="N"
                value="Y"
              ></b-form-checkbox>
              <span class="ml-1">{{
                voucher_is_active === "Y" ? "Active" : "Deactive"
              }}</span>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-lg-6 col-12">
            <b-form-checkbox
              class="j-checkbox pb-0 ml-3"
              v-model="cinema_specific_voucher"
              @change="openCinemaModal($event)"
              unchecked-value="N"
              value="Y"
              ><span
                >Applicable for selected Cinemas, Classes & Ticket Types</span
              ></b-form-checkbox
            >
          </div>
        </div>
        <b-collapse :visible="cinema_specific_voucher == 'Y'">
          <div
            class="new-border rounded-10 p-3 mb-4 back"
            v-if="cinema_specific_voucher == 'Y' && cinema_vouchers.length"
          >
            <div
              class="row"
              v-for="(cinema_voucher_obj, voucher_index) in cinema_vouchers"
              :key="voucher_index"
            >
              <div class="col-10 mt-3">
                <div class="row">
                  <div class="col-lg-6 col-12">
                    <div class="dropdown-curve-container">
                      <label
                        :class="
                          cinema_voucher_obj.cine_name &&
                          cinema_voucher_obj.cine_name
                            ? 'shift-up'
                            : ''
                        "
                        >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
                      >
                      <multiselect
                        v-model="cinema_voucher_obj.cine_name"
                        :options="cinemas"
                        :placeholder="$tc('Cinemas')"
                        label="cine_name"
                        track-by="cine_id"
                        @input="getScreensSeats('cinema_id', voucher_index)"
                        @remove="
                          removeSreenBasedSeats(
                            'cinema_id',
                            voucher_index,
                            $event
                          )
                        "
                      ></multiselect>
                    </div>
                  </div>
                  <div class="col-lg-6 col-12">
                    <div class="dropdown-curve-container">
                      <label
                        :class="
                          cinema_voucher_obj.ticket_name &&
                          cinema_voucher_obj.ticket_name
                            ? 'shift-up'
                            : ''
                        "
                        >Select Ticket Type</label
                      >
                      <multiselect
                        v-model="cinema_voucher_obj.ticket_name"
                        :options="cinema_voucher_obj.cinemaScreenTickets"
                        :multiple="true"
                        group-values="ticketsData"
                        group-label="screen_name"
                        :group-select="true"
                        :searchable="true"
                        :showLabels="false"
                        label="tt_name"
                        track-by="tt_id"
                        placeholder=""
                        v-b-tooltip.hover
                        :title="$t('Ticket type')"
                        :close-on-select="false"
                      >
                      </multiselect>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-lg-6 col-12">
                    <div class="dropdown-curve-container">
                      <label
                        :class="
                          cinema_voucher_obj.screen_name &&
                          cinema_voucher_obj.screen_name
                            ? 'shift-up'
                            : ''
                        "
                        >Select Screens</label
                      >
                      <multiselect
                        v-model="cinema_voucher_obj.screen_name"
                        :options="cinema_voucher_obj.cinemaScreen"
                        :searchable="true"
                        :multiple="true"
                        label="screen_name"
                        placeholder=""
                        track-by="screen_id"
                        :close-on-select="false"
                        @input="getScreensSeats('screen_id', voucher_index)"
                        @remove="
                          removeSreenBasedSeats(
                            'screen_id',
                            voucher_index,
                            $event
                          )
                        "
                      ></multiselect>
                    </div>
                  </div>
                  <div class="col-lg-6 col-12">
                    <div class="dropdown-curve-container">
                      <label
                        :class="
                          cinema_voucher_obj.seat_class &&
                          cinema_voucher_obj.seat_class
                            ? 'shift-up'
                            : ''
                        "
                        >Select Seats</label
                      >
                      <multiselect
                        v-model="cinema_voucher_obj.seat_class"
                        :options="cinema_voucher_obj.cinemaScreenSeats"
                        :multiple="true"
                        group-values="screensData"
                        group-label="screen_name"
                        :group-select="true"
                        :searchable="true"
                        :showLabels="false"
                        label="sst_seat_type"
                        placeholder=""
                        track-by="sst_id"
                        :close-on-select="false"
                      >
                      </multiselect>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-2 mt-3">
                <button
                  class="btn-transparent mb-3"
                  @click="removeCinemaVouchers(voucher_index)"
                >
                  <img
                    src="@/assets/img/icons/minus.svg"
                    height="35"
                    width="35"
                  />
                </button>
              </div>
            </div>
            <div
              class="row d-flex align-items-center justify-content-center border-top mt-4 mb-5 position-relative"
            >
              <button
                @click.prevent.stop="addCinemaVouchers()"
                class="btn-transparent add-more-button"
              >
                <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
              </button>
            </div>
          </div>
        </b-collapse>

        <!-- Voucher Used For -->
        <div class="row mb-3">
          <div class="col-6">
            <div class="input-material-textarea">
              <textarea
                v-model="vouchers_used_for"
                name="usedfor"
                id="usedfor"
                rows="3"
                class="rounded-10"
              ></textarea>
              <label class="active">Vouchers Used For</label>
            </div>
          </div>
        </div>

        <!-- Voucher Specific Cinemas -->
        <div class="row mb-3" v-if="cinema_specific_voucher == 'N'">
          <div class="col-xl-6 col-lg-6 col-12">
            <div class="dropdown-curve-container">
              <label :class="voucher_specific_cinemas.length ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                v-model="voucher_specific_cinemas"
                :options="cinemas"
                placeholder=""
                v-validate="{ required: 'required' }"
                label="cine_name"
                track-by="cine_id"
                :searchable="true"
                :multiple="true"
                :close-on-select="false"
              ></multiselect>
              <p class="text-danger">
                <span v-if="custom_errors.only_cinema_error">{{
                  custom_errors.only_cinema_error
                }}</span>
              </p>
            </div>
          </div>
        </div>

        <!-- Voucher Movies -->
        <div class="row mb-2">
          <div class="col-3">
            <div class="d-flex align-items-center">
              <b-form-checkbox
                v-model="is_foreign_movie_applicable"
                unchecked-value="N"
                value="Y"
                class="j-checkbox pb-0"
              ></b-form-checkbox>
              <span class="ml-1">Is Applicable On Foreign Movies</span>
            </div>
          </div>
          <div class="col-5">
            <div class="dropdown-curve-container">
              <label :class="selectedMovieFormats.length > 0 ? 'shift-up' : ''"
                >Select Applicable Formats</label
              >
              <multiselect
                v-model="selectedMovieFormats"
                :options="movieFormats"
                placeholder=""
                label="mf_name"
                :multiple="true"
                track-by="mf_id"
                :close-on-select="false"
              ></multiselect>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-3">
            <div>
              <span>Movies:</span>
            </div>
            <div class="d-flex align-items-center">
              <!-- <b-form-checkbox switch class="mx-2"></b-form-checkbox> -->
              <b-form-radio
                value="movies_applicable"
                class="j-radio ml-2 pb-0"
                v-model="voucher_movies.is_applicable"
              >
              </b-form-radio>
              <div>
                <span style="text-transform: capitalize">Applicable</span>
              </div>
              <!---strong class="mx-3">OR</strong---->

              <!-- <b-form-checkbox switch class="mx-2"></b-form-checkbox> -->
              <b-form-radio
                value="movies_not_applicable"
                class="j-radio ml-2 pb-0"
                v-model="voucher_movies.is_applicable"
              >
                <div>
                  <span>Not Applicable</span>
                </div>
              </b-form-radio>
            </div>
          </div>
          <div class="col-5">
            <div class="dropdown-curve-container">
              <label :class="movies && movies.length > 0 ? 'shift-up' : ''"
                >Select Movies</label
              >
              <multiselect
                v-model="selectedMovies"
                :options="movies"
                placeholder=""
                label="movie"
                :multiple="true"
                track-by="md_id"
                group-values="Movies"
                group-label="label"
                :group-select="true"
                :close-on-select="false"
              ></multiselect>
            </div>
          </div>
        </div>

        <!-- Voucher start/end time -->
        <div class="row mb-3">
          <div class="col-lg-3 col-md-6 col-12">
            <div class="input-material">
              <div class="add-datepicker custom-date">
                <button
                  class="btn-clearDate"
                  v-if="voucher_date_time.voucher_start_date"
                  v-on:click="voucher_date_time.voucher_start_date = null"
                >
                  ✖
                </button>
                <div class="d-flex align-items-center">
                  <Datepicker
                    :monday-first="true"
                    ref="programaticOpen"
                    v-model="voucher_date_time.voucher_start_date"
                    type="date"
                    class="theme-custom-date-time w-100"
                    typeable
                    id="voucher_startdate"
                    name="voucher_startdate"
                    :disabled-dates="disabledDates"
                    v-b-tooltip.hover
                    :title="$t('voucher_start_date_tooltip')"
                  ></Datepicker>
                  <!--Tooltip :title="$t('voucher_start_date_tooltip')" /-->
                </div>
                <label
                  :class="voucher_date_time.voucher_start_date ? 'active' : ''"
                  >{{ $t("startdate") }}</label
                >
              </div>
            </div>
            <p class="text-danger">
              <span>{{ custom_errors.voucher_start_date_error }}</span>
            </p>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <div class="input-material">
              <div class="add-datepicker custom-date">
                <button
                  class="btn-clearDate"
                  v-if="voucher_date_time.voucher_end_date"
                  v-on:click="voucher_date_time.voucher_end_date = null"
                >
                  ✖
                </button>
                <div class="d-flex align-items-center">
                  <Datepicker
                    :monday-first="true"
                    ref="programaticOpen"
                    v-model="voucher_date_time.voucher_end_date"
                    type="date"
                    class="theme-custom-date-time w-100"
                    typeable
                    id="voucher_enddate"
                    name="voucher_enddate"
                    :disabled-dates="disabledDates"
                    v-b-tooltip.hover
                    :title="$t('voucher_start_date_tooltip')"
                  >
                  </Datepicker>
                  <!--Tooltip :title="$t('voucher_start_date_tooltip')" /-->
                </div>
                <label
                  :class="voucher_date_time.voucher_end_date ? 'active' : ''"
                  >{{ $t("enddate") }}</label
                >
              </div>
            </div>
            <p class="text-danger">
              <span>{{ custom_errors.voucher_end_date_error }}</span>
            </p>
          </div>
          <div class="col-lg-6 col-xl-3 mb-1">
            <div class="d-flex justify-content-center align-items-center">
              <vue-timepicker
                manual-input
                v-model="voucher_date_time.voucher_start_time"
                id="starttime"
                name="starttime"
                :placeholder="$tc('starttime')"
                format="HH:mm"
                class="time_picker"
                input-width="100%"
                auto-scroll
                lazy
                v-b-tooltip.hover
                :title="$t('voucher_start_time')"
              ></vue-timepicker>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 mb-1">
            <div class="d-flex justify-content-center align-items-center">
              <vue-timepicker
                manual-input
                v-model="voucher_date_time.voucher_end_time"
                id="endtime"
                name="endtime"
                :placeholder="$tc('endtime')"
                format="HH:mm"
                class="time_picker"
                input-width="100%"
                auto-scroll
                lazy
                v-b-tooltip.hover
                :title="$t('voucher_end_time')"
              ></vue-timepicker>
            </div>
          </div>
        </div>

        <!-- Voucher multiple codes -->
      </div>

      <!-- Voucher Settings -->
      <div class="new-border rounded-10 p-3 mb-3 back">
        <div class="section-title mb-3" style="font-size: 20px">
          {{ $t("voucher") }} {{ $tc("setting", 2) }}
        </div>

        <div class="row" style="height: 40px">
          <div class="col-lg-6 col-xl-3 align-self-center mb-4">
            <div class="d-flex align-items-center">
              <b-form-checkbox
                v-model="voucher_settings.is_code_required"
                unchecked-value="N"
                value="Y"
                class="j-checkbox pb-0"
                @change="
                  onChangeVoucherSettings('voucher_code_required', $event)
                "
              ></b-form-checkbox>
              <span class="ml-1">{{ $t("is_code_required") }}</span>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-4">
            <div class="d-flex align-items-center">
              <b-form-checkbox
                v-model="voucher_settings.is_open"
                unchecked-value="N"
                value="Y"
                class="j-checkbox pb-0"
                disabled
                @input="onChangeVoucherSettings('is_open', $event)"
              ></b-form-checkbox>
              <span class="ml-1">{{ $t("openVoucher") }}</span>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-4">
            <div class="d-flex align-items-center">
              <b-form-checkbox
                class="j-checkbox pb-0"
                v-model="voucher_settings.share_with_dist"
                unchecked-value="N"
                value="Y"
              ></b-form-checkbox>
              <span class="ml-1">{{ $t("is_share_with_distributor") }}</span>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-4">
            <div class="d-flex align-items-center">
              <b-form-checkbox
                class="j-checkbox pb-0"
                v-model="voucher_settings.add_in_rev"
                unchecked-value="N"
                value="Y"
              ></b-form-checkbox>
              <span class="ml-1">{{ "Add in Revenue" }}</span>
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-3">
            <div class="d-flex align-items-center">
              <b-form-checkbox
                class="j-checkbox pb-0"
                v-model="voucher_settings.is_web_rate_card"
                unchecked-value="N"
                value="Y"
              ></b-form-checkbox>
              <span class="ml-1">Use Web Rate Card</span>
            </div>
          </div>
          <div class="col-3">
            <div class="d-flex align-items-center">
              <b-form-checkbox
                class="j-checkbox pb-0"
                v-model="voucher_settings.is_redemptions"
                unchecked-value="N"
                value="Y"
              ></b-form-checkbox>
              <span class="ml-1">Is Redemptions</span>
            </div>
          </div>
        </div>
        <!--Collapse-->
        <b-collapse
          v-model="voucher_settings.is_open"
          v-if="voucher_settings.is_open == 'Y'"
        >
          <div
            class="d-flex internal-border-new mt-2"
            style="
              border-radius: 10px;
              padding-top: 10px;
              flex-wrap: wrap;
              background-color: white;
            "
          >
            <div class="col-lg-6 col-xl-3 align-self-center mb-2 pt-2">
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  class="j-checkbox pb-0"
                  v-model="voucher_settings.is_complimentary"
                  unchecked-value="N"
                  value="Y"
                ></b-form-checkbox>
                <span class="ml-1">{{ $t("is_complimentary_ticket") }}</span>
              </div>
            </div>

            <div
              class="col-lg-6 col-xl-3 align-self-center mb-2"
              v-if="
                voucher_settings.is_open == 'Y' &&
                voucher_settings.is_complimentary == 'N'
              "
            >
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  class="j-checkbox pb-0"
                  v-model="voucher_settings.allow_cash_refund"
                  unchecked-value="N"
                  value="Y"
                ></b-form-checkbox>
                <span class="ml-1">{{ $t("allow_cash_refund") }}</span>
              </div>
            </div>

            <div
              class="col-lg-6 col-xl-3 align-self-center mb-2 pt-2"
              v-if="voucher_settings.is_complimentary == 'Y'"
            >
              <div class="d-flex align-items-center">
                <div class="dropdown-curve-container">
                  <label
                    :class="
                      voucher_settings.ticket_type_selected ? 'shift-up' : ''
                    "
                    >{{ $tc("ticketType") }}</label
                  >
                  <multiselect
                    v-model="voucher_settings.ticket_type_selected"
                    :options="tickets"
                    label="tt_name"
                    track-by="tt_id"
                    placeholder=""
                    :multiple="false"
                    v-b-tooltip.hover
                    :title="$t('Ticket type')"
                  />
                </div>

                <!--Tooltip :title="$t('Ticket type')" /-->
              </div>
            </div>

            <div
              class="col-lg-6 col-xl-3 align-self-center mb-2 pt-2"
              v-if="voucher_settings.is_complimentary == 'Y'"
            >
              <div class="d-flex align-items-center">
                <div class="dropdown-curve-container">
                  <label
                    :class="
                      voucher_settings.selected_complimentary_cinema
                        ? 'shift-up'
                        : ''
                    "
                    >{{ "Cinema" }}</label
                  >
                  <multiselect
                    v-model="voucher_settings.selected_complimentary_cinema"
                    :options="cinemas"
                    label="cine_name"
                    track-by="cine_id"
                    @select="getScreenList($event)"
                    placeholder=""
                    :multiple="false"
                    v-b-tooltip.hover
                    :title="$t('Cinema For Complemetory Ticket')"
                  />
                </div>

                <!--Tooltip :title="$t('Cinema For Complemetory Ticket')" /-->
              </div>
            </div>

            <div
              class="col-lg-6 col-xl-3 align-self-center mb-2 pt-2"
              v-if="
                voucher_settings.is_complimentary == 'Y' &&
                voucher_settings.selected_complimentary_cinema
              "
            >
              <div class="d-flex align-items-center">
                <div class="dropdown-curve-container">
                  <label
                    :class="
                      voucher_settings.selected_complimentary_screen
                        ? 'shift-up'
                        : ''
                    "
                    >{{ $tc("screen", 1) }}</label
                  >
                  <!-- <multiselect
                    v-model="voucher_settings.selected_screen"
                    @select="onSelectScreen($event)"
                    :options="ScreenList"
                    label="screen_name"
                    track-by="screen_id"
                    placeholder=""
                    :multiple="false"
                    v-b-tooltip.hover
                    :title="$t('Screen For Complemetory Ticket')"
                  /> -->
                  <multiselect
                    v-model="voucher_settings.selected_complimentary_screen"
                    :options="screensByCinema"
                    label="screen_name"
                    track-by="screen_id"
                    placeholder=""
                    :multiple="false"
                    v-b-tooltip.hover
                    :title="$t('Cinema For Complemetory Ticket')"
                  />
                </div>

                <!--Tooltip :title="$t('Screen For Complemetory Ticket')" /-->
              </div>
            </div>
          </div>
        </b-collapse>
        <!--Collapse-->
      </div>

      <!-- Voucher Reporting -->
      <div class="new-border rounded-10 p-3 mb-3 back" v-if="isEpix">
        <div class="section-title mb-3" style="font-size: 20px">
          {{ "Reporting" }} {{ $tc("setting", 2) }}
        </div>

        <div class="row align-items-center mb-2" style="height: 25px">
          <div class="col-lg-6 col-xl-3" v-if="isEpix">
            <div class="d-flex align-items-center justify-content-start">
              <b-form-checkbox
                class="j-checkbox pb-0 ml-3"
                v-model="voucher_settings.has_v_reporting_percent"
                unchecked-value="N"
                value="Y"
              ></b-form-checkbox>
              <span class="font-weight-bold">Report Specific Percent</span>
            </div>
          </div>
          <div
            class="col-lg-6 col-xl-3"
            v-if="isEpix && voucher_settings.has_v_reporting_percent == 'Y'"
          >
            <div class="d-flex align-items-center justify-content-start">
              <span class="font-weight-bold">Reporting Percent</span>
              <div class="input-material-sm mx-2">
                <input
                  style="text-align: right"
                  v-model="voucher_settings.v_reporting_percent"
                  name="dist_share_value"
                  id="dist_share_value"
                  type="text"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Voucher Configuration -->
      <div class="new-border rounded-10 p-3 mb-4 back">
        <div class="section-title mb-4" style="font-size: 20px">
          {{ $t("voucher") }} {{ $tc("configuration", 1) }}
        </div>

        <div class="row" style="align-items: baseline">
          <div
            class="col-lg-8 col-xl-8 align-self-center mb-2 align-items-center"
          >
            <div class="row mx-0">
              {{ $t("redeemAt") }}:
              <b-form-checkbox
                v-model="voucher_config.redeem_at_box"
                class="j-checkbox mx-3 pb-0"
              >
                <div class="text-capitalize">{{ $t("boxoffice") }}</div>
              </b-form-checkbox>
              <b-form-checkbox
                :disabled="voucher_config.value_voucher == 'N'"
                v-model="voucher_config.redeem_at_fnb"
                class="j-checkbox mx-3 pb-0"
              >
                <div class="text-capitalize">{{ $t("concession") }}</div>
                <span class="text-muted fs-12">{{
                  voucher_config.value_voucher == "N" ? "(Not Applicable)" : ""
                }}</span>
              </b-form-checkbox>
              <b-form-checkbox
                v-if="voucher_settings.is_open != 'Y'"
                v-model="voucher_config.redeem_at_online"
                class="j-checkbox mx-3 pb-0"
              >
                <div class="text-capitalize">{{ $t("online") }}</div>
              </b-form-checkbox>
            </div>
          </div>

          <div
            class="d-flex mb-2 col-lg-4 col-xl-4 justify-content-center"
            v-if="showConfiguration"
          >
            <span>{{ $t("isValueVoucher") }}</span>
            <b-form-checkbox
              class="ml-3 j-checkbox pb-0"
              v-model="voucher_config.value_voucher"
              unchecked-value="N"
              value="Y"
              @change="onChangeValueVoucher($event)"
            ></b-form-checkbox>
          </div>
        </div>
        <div class="row">
          <div
            class="d-flex m-3"
            v-if="
              voucher_config.value_voucher == 'N' &&
              showConfiguration &&
              voucher_settings.is_open == 'N'
            "
          >
            <div>
              <b-form-radio
                value="bogo_voucher"
                class="j-radio ml-2 pb-0"
                v-model="voucher_config.is_bogo_voucher"
              >
                <span style="text-transform: capitalize"
                  >Buy Tickets And Get Free Tickets</span
                >
              </b-form-radio>
            </div>
            <div>
              <b-form-radio
                value="is_not_bogo_voucher"
                class="j-radio ml-2 pb-0"
                v-model="voucher_config.is_bogo_voucher"
              >
                <span style="text-transform: capitalize">Get Free Tickets</span>
              </b-form-radio>
            </div>
          </div>
          <div
            class="internal-border"
            v-if="
              voucher_settings.is_open == 'N' &&
              voucher_config.is_bogo_voucher == 'bogo_voucher'
            "
            style="background-color: white"
          >
            <div
              v-if="voucher_config.value_voucher == 'N' && showConfiguration"
              class="col-lg-4 col-xl-4 align-self-center mb-1"
            >
              {{ $t("buyngetfreeticket") }}
              <div
                class="offer-content-wrapper"
                style="padding-left: 0px; padding-top: 15px"
              >
                <div class="row">
                  <div class="col-lg-12 col-xl-12 mb-3">
                    <div class="d-flex align-items-center">
                      {{ $t("buy") }}
                      <div class="input-material-sm mx-1">
                        <input
                          v-validate="'required|numeric'"
                          name="buy_ticket"
                          id="buy_ticket"
                          v-model="voucher_config.voucher_buy_no_of_ticket"
                          type="text"
                        />
                      </div>
                      {{ $t("get") }}
                      <div class="input-material-sm mx-2">
                        <input
                          v-validate="'required|numeric'"
                          name="get_ticket"
                          id="get_ticket"
                          v-model="voucher_config.voucher_get_free_ticket"
                          type="text"
                        />
                      </div>
                      {{ $t("ofticketsfree") }}
                    </div>
                  </div>
                </div>
              </div>
              <p class="error_message">
                <span
                  v-if="
                    (submitted && errors.has('buy_ticket')) ||
                    (submitted && errors.has('get_ticket'))
                  "
                  >{{
                    errors.first("buy_ticket") || errors.first("get_ticket")
                  }}</span
                >
              </p>
            </div>

            <!-- VOUCHER VALUE -->
            <div
              v-if="voucher_config.value_voucher == 'Y' && showConfiguration"
              class="col-lg-3 col-xl-2 align-self-center mb-1"
            >
              <div class="d-flex align-items-center">
                <span>{{ $tc("value") }}</span>
                <div class="input-material-sm mx-2">
                  <input
                    style="text-align: right"
                    v-model="voucher_config.voucher_amount"
                    v-validate="'required|decimal'"
                    name="voucher_amt"
                    id="voucher_amt"
                    type="text"
                  />
                </div>
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('voucher_amt')">{{
                  errors.first("voucher_amt")
                }}</span>
              </p>
            </div>

            <!-- IS PERCENTAGE -->
            <div
              v-if="voucher_config.value_voucher == 'Y' && showConfiguration"
              :class="
                voucher_config.voucher_is_percentage == 'Y'
                  ? 'col-lg-3 col-xl-2 align-self-center mb-2'
                  : 'col-lg-3 col-xl-3 align-self-center mb-2'
              "
            >
              <div class="d-flex align-items-center">
                <span>{{ $t("Percentage") }}</span>
                <b-form-checkbox
                  class="ml-3 j-checkbox pb-0"
                  v-model="voucher_config.voucher_is_percentage"
                  unchecked-value="N"
                  value="Y"
                ></b-form-checkbox>
              </div>
            </div>

            <!-- MIN BILL AMOUNT  -->
            <div
              :class="
                voucher_config.voucher_is_percentage == 'Y'
                  ? 'col-lg-6 col-xl-5 align-self-center mb-0'
                  : 'col-lg-6 col-xl-7 align-self-center mb-0'
              "
              v-if="showConfiguration"
              :style="
                voucher_config.value_voucher == 'N' ? 'padding-top:15px' : ''
              "
            >
              <div class="d-flex align-items-center">
                <span>{{ $tc("minBill_Redemption") }}</span>
                <div class="input-material-sm mx-2">
                  <input
                    style="text-align: right"
                    v-model="voucher_config.min_ticket_amount"
                    v-validate="'required|numeric'"
                    name="voucher_min_amt"
                    id="voucher_min_amt"
                    type="text"
                  />
                </div>
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('voucher_min_amt')">{{
                  errors.first("voucher_min_amt")
                }}</span>
              </p>
            </div>

            <!-- MAX BILL AMOUNT -->
            <div
              class="col-lg-3 col-xl-3 align-self-center mb-1"
              v-if="
                showConfiguration && voucher_config.voucher_is_percentage == 'Y'
              "
              :style="
                voucher_config.value_voucher == 'N' ? 'padding-top:15px' : ''
              "
            >
              <div class="d-flex align-items-center">
                <span v-if="voucher_config.value_voucher == 'Y'"
                  >{{ $tc("Max") }} {{ $tc("discount") }}</span
                >
                <span v-else>{{ $t("maxfreeticketpertransaction") }}</span>
                <div class="input-material-sm mx-2">
                  <input
                    style="text-align: right"
                    v-model="voucher_config.voucher_max_redemption_amount"
                    name="voucher_max_amt"
                    id="voucher_max_amt"
                    type="text"
                  />
                </div>
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('voucher_max_amt')">{{
                  errors.first("voucher_max_amt")
                }}</span>
              </p>
            </div>
          </div>
          <div class="internal-border" style="background-color: white" v-else>
            <div class="row">
              <div class="col-lg-12 col-xl-12 mx-2 mb-3">
                <div class="d-flex align-items-center">
                  Get
                  <div class="input-material-sm mx-2">
                    <input
                      v-validate="'required|numeric'"
                      name="get_ticket"
                      id="get_ticket"
                      v-model="voucher_config.voucher_get_free_ticket"
                      type="text"
                    />
                  </div>
                  Tickets Free
                </div>
              </div>
            </div>
          </div>
          <!-- REDEEMABLE ON NET-VALUE / GROSS AMOUNT  -->
          <div
            class="col-lg-12 mb-4 d-flex align-items-center"
            v-if="showConfiguration"
          >
            <div>
              <span>{{ $tc("redeem") }} On :</span>
            </div>
            <div class="d-flex align-items-center">
              <!-- <b-form-checkbox switch class="mx-2"></b-form-checkbox> -->
              <b-form-radio
                value="voucherRedeemNetAmount"
                class="j-radio ml-2 pb-0"
                v-model="voucher_config.voucher_redemption_on"
              >
              </b-form-radio>
              <div>
                <span style="text-transform: capitalize">{{
                  $tc("netAmount")
                }}</span>
              </div>
              <!---strong class="mx-3">OR</strong---->

              <!-- <b-form-checkbox switch class="mx-2"></b-form-checkbox> -->
              <b-form-radio
                value="voucherRedeemGrossAmount"
                class="j-radio ml-2 pb-0"
                v-model="voucher_config.voucher_redemption_on"
              >
                <div>
                  <span>{{ $tc("grossAmount") }}</span>
                </div>
              </b-form-radio>
            </div>
          </div>

          <div class="row col-12" style="margin-left: 1px">
            <div class="align-self-center mb-4">
              <div class="d-flex align-items-center">
                <span>{{ $tc("voucherRedemptionperPatron") }}</span>
                <div class="input-material-sm mx-2">
                  <input
                    style="text-align: right"
                    v-model="voucher_config.voucher_redemption_per_patron"
                    type="number"
                  />
                </div>
              </div>
            </div>

            <div class="align-self-center mb-4">
              <div class="d-flex align-items-center">
                <span>Total {{ $tc("redemption") }}</span>
                <div class="input-material-sm mx-2">
                  <input
                    style="text-align: right"
                    v-model="voucher_config.voucher_total_redemption"
                    type="number"
                  />
                </div>
              </div>
            </div>

            <div class="align-self-center mb-4" v-if="showConfiguration">
              <div class="d-flex align-items-center">
                <span>{{ $tc("voucherRedemptionPercentageAtFNB") }}</span>
                <div class="input-material-sm mx-2">
                  <input
                    style="text-align: right"
                    v-model="voucher_config.voucher_redemption_percent_fnb"
                    type="number"
                    :min="0"
                    :max="100"
                  />
                </div>
                %
              </div>
            </div>
          </div>

          <div class="col-lg-12 col-xl-12 align-self-center mb-2">
            <div
              class="row mx-0 internal-border-new rounded-10 px-2 pt-2"
              style="background-color: white"
            >
              {{ $t("show") }} {{ $t("days") }}:
              <b-form-checkbox
                v-for="(weekdaysLoop, weekdaysKey) in weekDays"
                :key="weekdaysKey"
                v-model="weekDays[weekdaysKey]"
                class="j-checkbox mx-2 mb-2 pb-0"
                @change="onChangeWeekdays($event, weekdaysKey)"
              >
                <div class="text-capitalize">{{ weekdaysKey }}</div>
              </b-form-checkbox>
            </div>
            <p class="error_message">
              <span>{{ custom_errors.weekday_errors }}</span>
            </p>
          </div>

          <!-- <div class="col-lg-12 col-xl-12 align-self-center mb-3">
            <div class="row mx-0">
              {{ $t('Applicablefor') }}:
              <b-form-checkbox
                v-for="(applicable, applicableForKey) in applicableFor"
                :key="applicableForKey"
                v-model="applicableFor[applicableForKey]"
                class="j-checkbox mx-3 mb-3"
                @change="onChangeApplicable($event, applicableForKey)"
              >
                <div class="text-capitalize">{{ applicableForKey }}</div>
              </b-form-checkbox>
            </div>
            <p class="error_message">
              <span>
                {{ $t(applicableerror
                ) }}
              </span>
            </p>
          </div> -->

          <!-- <div class="col-lg-12 col-xl-12 align-self-center mb-4">
            <div class="row mx-0">
              {{ $t('vouchersissuedbypartnername') }} :
              <div class="dropdown-curve-container">
                <custommultiselect
                  v-model="voucher_config.vp_id"
                  :options="voucherPartnerList"
                  placeholder="Select Partner"
                  label="vp_partner_name"
                  isSingleId="vp_id"
                  :multiple="false"
                  track-by="vp_id"
                ></custommultiselect>
              </div>
            </div>
          </div>-->

          <div class="col-lg-12 col-xl-12">
            <div class="d-flex">
              <div class="input-material-textarea">
                <textarea
                  v-model="voucher_terms"
                  v-validate="'required'"
                  name="termsandco"
                  id="termsandco"
                  rows="5"
                  class="rounded-10"
                ></textarea>
                <label class="active">{{ $t("termsandconditions") }}</label>
              </div>
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('termsandco')">{{
                errors.first("termsandco")
              }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="new-border rounded-10 p-3 mb-4 back">
        <div class="section-title mb-4" style="font-size: 20px">
          {{ $t("voucher") }} {{ $t("split") }} {{ $tc("configuration", 1) }}
        </div>
        <div class="row" style="height: 35px">
          <div class="col-lg-6 col-xl-4 mb-2">
            <div class="dropdown-curve-container">
              <label
                :class="
                  voucher_split.client &&
                  String(voucher_split.client).length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $tc("client") }}</label
              >
              <div class>
                <multiselect
                  v-model="voucher_split.client"
                  :placeholder="$tc('client')"
                  :options="clients"
                  label="client_name"
                  track-by="client_id"
                  :multiple="false"
                ></multiselect>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-4 align-self-center mb-2">
            <div class="d-flex align-items-center justify-content-center">
              <span>{{ $tc("share") }} {{ $tc("value") }}</span>
              <div class="input-material-sm mx-2">
                <input
                  style="text-align: right"
                  v-model="voucher_split.share_value"
                  name="share_value"
                  id="share_value"
                  type="text"
                />
              </div>
            </div>
          </div>

          <!-- IS PERCENTAGE -->
          <div class="col-lg-6 col-xl-4 align-self-center mb-2">
            <div class="d-flex align-items-center justify-content-center">
              <span>{{ $t("isPercentage") }}</span>
              <b-form-checkbox
                class="ml-3 j-checkbox pb-0"
                v-model="voucher_split.share_is_percentage"
                unchecked-value="N"
                value="Y"
                disabled
              ></b-form-checkbox>
            </div>
          </div>
        </div>
        <div class="row p-2" style="height: 35px">
          <div class="col-lg-6 col-xl-4 align-self-center mb-2">
            <div class="d-flex align-items-center">
              <div class="align-self-center">Distributor Share Threshold</div>
              <div class="input-material-sm mx-2">
                <input
                  style="text-align: right"
                  v-model="offer_dist_share_threshold"
                  name="dist_share_value"
                  id="dist_share_value"
                  type="text"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- dist share values -->
      <section class="mb-2">
        <div
          class="section-title mb-3 d-flex justify-content-between section-border section-border"
          style="padding: 6px; align-items: center"
          v-b-toggle.dist_share
        >
          <span class="fs">Distributor Reporting Values</span>

          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>

        <b-collapse
          id="dist_share"
          class="mt-2"
          v-model="sectionCollapse.dist_share"
        >
          <div class="new-border rounded-10 back">
            <template v-if="distShareValues.length">
              <div
                class="row my-2 p-2 justify-content-between"
                v-for="(distValues, distValueIndex) in distShareValues"
                :key="distValueIndex"
              >
                <div class="col-10">
                  <div class="row justify-content-between">
                    <div class="col-3">
                      <div class="dropdown-curve-container">
                        <label
                          :class="distValues.seat_type_id ? 'shift-up' : ''"
                          >Seat Type</label
                        >
                      </div>
                      <div>
                        <!-- v-model="OfferConfiguraion.cine_id" -->
                        <!-- @input="getScreenList" -->

                        <!-- <multiselect v-model="distValues.seat_type_id" :options="seatTypesList" label="sst_seat_type"
                        :multiple="false" track-by="sst_id">
                      </multiselect> -->
                        <multiselect
                          v-model="distValues.seat_type_id"
                          :options="seatTypesListForDist"
                          :multiple="true"
                          group-values="screensData"
                          group-label="screen_name"
                          :group-select="true"
                          :searchable="true"
                          :showLabels="false"
                          label="sst_seat_type"
                          placeholder=""
                          track-by="sst_id"
                          :close-on-select="false"
                        >
                        </multiselect>
                      </div>
                    </div>
                    <div class="col-3">
                      <div class="dropdown-curve-container">
                        <label
                          :class="distValues.ticket_type_id ? 'shift-up' : ''"
                          >Ticket Type</label
                        >
                      </div>
                      <div>
                        <!-- v-model="OfferConfiguraion.cine_id" -->
                        <!-- @input="getScreenList" -->

                        <multiselect
                          v-model="distValues.ticket_type_id"
                          :options="ticketsForDist"
                          label="tt_name"
                          :multiple="true"
                          track-by="tt_id"
                          :close-on-select="false"
                        >
                        </multiselect>
                      </div>
                    </div>
                    <div class="col-3">
                      <div class="input-material">
                        <input
                          placeholder="."
                          type="text"
                          v-model="distValues.dist_value"
                          name="dist_value"
                          id="dist_value"
                        />
                        <label>Dist. Value</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-2">
                  <button
                    class="btn-transparent mb-3"
                    @click="removeDistValue(distValueIndex)"
                  >
                    <img
                      src="@/assets/img/icons/minus.svg"
                      height="35"
                      width="35"
                    />
                  </button>
                </div>
              </div>
            </template>
            <div class="row justify-content-center">
              <button
                class="btn-transparent mb-3"
                @click="addMoreDistShareValues()"
              >
                <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
              </button>
            </div>
          </div>
        </b-collapse>
      </section>
      <!-- dist share values -->

      <div class="col-12 mt-4 text-center">
        <button @click="onSubmitUpdateData()" class="btn-blue">
          Update {{ $t("voucher") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import MovieService from "@/services/MovieService";
import scheduleService from "@/services/scheduleService";
import ClientService from "@/services/ClientService";
import MarketingService from "@/services/MarketingService";

import DatePicker from "vue2-datepicker";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import { generateRandomCode } from "@/helper/collection";
import moment from "moment";
import { uniqBy, chain } from "lodash";
import { CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";

let initialStartDate = moment(
  `${moment().subtract(1, "days").format("YYYY-MM-DD")} 24:00:00`
).format();

export default {
  components: { DatePicker, VueTimepicker },
  data() {
    return {
      sectionCollapse: {
        dist_share: false,
      },
      voucher_code: `VO-${generateRandomCode(8)}`,
      voucher_name: null,
      voucher_receipt_print: "",
      voucher_is_active: "Y",
      cinema_specific_voucher: "N",
      cinemas: [],
      cinema_vouchers: [],
      voucher_specific_cinemas: [],
      vouchers_used_for: "",
      movies: [],
      movieFormats: [],
      is_foreign_movie_applicable: "N",
      voucher_movies: {
        is_applicable: "movies_applicable",
      },
      selectedMovies: [],
      selectedMovieFormats: [],
      voucher_date_time: {
        voucher_start_date: initialStartDate,
        voucher_end_date: null,
        voucher_start_time: "00:00",
        voucher_end_time: "23:59",
      },
      disabledDates: {
        to: new Date(Date.now() - 8640000),
      },
      voucher_multiple_codes: {
        is_required: false,
        no_of_vouchers: 10,
        prefix_text: "",
        is_random: true,
        is_sequence: false,
        voucher_code_length: 8,
        sequence_start: generateRandomCode(8),
      },
      voucher_settings: {
        is_code_required: "Y",
        is_open: "N",
        open_voucher_settings: false,
        is_complimentary: "N",
        allow_cash_refund: "N",
        share_with_dist: "N",
        add_in_rev: "N",
        ticket_type_selected: null,
        selected_complimentary_cinema: null,
        selected_complimentary_screen: null,
        is_web_rate_card: "N",
        is_redemptions: "N",
        has_v_reporting_percent: "N",
        v_reporting_percent: null,
      },
      tickets: [],
      ticketsForDist: [],
      distShareValues: [],
      voucherDistShareValues: [],
      seatTypesListForDist: [],
      screensByCinema: [],
      voucher_config: {
        redeem_at_box: true,
        redeem_at_fnb: false,
        redeem_at_online: false,
        value_voucher: "Y",
        voucher_buy_no_of_ticket: null,
        voucher_get_free_ticket: null,
        min_ticket_amount: null,
        voucher_max_redemption_amount: null,
        voucher_amount: null,
        voucher_is_percentage: "Y",
        voucher_redemption_on: "voucherRedeemGrossAmount",
        voucher_redemption_per_patron: null,
        voucher_total_redemption: null,
        voucher_redemption_percent_fnb: null,
        is_bogo_voucher: "bogo_voucher",
      },
      weekDays: {
        selectAll: true,
        sunday: true,
        monday: true,
        tuesday: true,
        wednesday: true,
        thursday: true,
        friday: true,
        saturday: true,
      },
      voucher_terms: "",
      voucher_split: {
        client: null,
        share_value: 0,
        share_is_percentage: "Y",
      },
      clients: [],
      cinemaScreens: [],
      screenSeats: [],
      screenTickets: [],
      submitted: false,
      custom_errors: {
        weekday_errors: "",
        voucher_start_date_error: "",
        only_cinema_error: "",
        voucher_end_date_error : ""
      },
      currentVoucherData: {
        vouchers: {},
        promo_cinema_settings: [],
        promo_movie_settings: [],
        vs_settings: {},
      },
      voucherUpdateData: {
        inactivePromoCinemaFields: [],
        inactiveMovieFields: [],
        addMovieFields: [],
        addCinemaPromoFields: [],
        vouchers: {},
        promo_cinema_settings: [],
      },
      offer_dist_share_threshold: 0,
    };
  },
  beforeMount() {
    Promise.all([
      this.getCinemas(),
      this.getMovies(),
      this.getTicketTypeList(),
      this.getMovieFormats(),
    ]).then(() => {
      if (this.$route.params.voucher_id) {
        this.getVoucherData();
      }
    });
    console.log("router params", this.$route.params);
  },
  computed: {
    isEpix() {
      return CLIENT_NAMES_OBJ.EPIX.includes(String(this.CLIENT_SETUP_NAME));
    },
    showConfiguration() {
      if (
        this.voucher_settings.is_open == "Y" ||
        this.voucher_settings.is_complimentary == "Y"
      ) {
        return false;
      } else {
        return true;
      }
    },
    currentVoucherId() {
      let route_voucher_id = null;
      if (this.$route.params.voucher_id) {
        route_voucher_id = this.$route.params.voucher_id;
      }
      return route_voucher_id;
    },
  },
  watch: {
    "sectionCollapse.dist_share"(newVal) {
      if (
        this.sectionCollapse.dist_share &&
        !this.seatTypesListForDist.length
      ) {
        this.getAllScreenSeatsForDistShares();
      }
    },
  },
  methods: {
    moment,
    addMoreDistShareValues() {
      this.distShareValues.push({
        seat_type_id: null,
        ticket_type_id: null,
        dist_value: null,
      });
    },
    removeDistValue(index) {
      this.distShareValues.splice(index, 1);
    },
    convertTime(date, time) {
      // const d = moment(date).format("L");
      const d = moment(date).format("YYYY-MM-DD");
      const newdate = moment(d + " " + time).format();
      return newdate;
    },
    getCinemas: async function () {
      this.cinemas = [];
      try {
        let payload = {
          tableName: "ms_cinemas",
          cine_is_active: "Y",
        };
        const response = await MasterService.GetActiveList(payload);
        const { data } = response;
        if (data.status && data.Records.length) {
          this.cinemas = [...data.Records];
        } else {
          this.$toasted.show(data.message);
        }
      } catch (error) {
        console.log(error, "from cinemas");
      }
    },
    openCinemaModal: function (event) {
      this.voucher_specific_cinemas = [];
      if (event == "Y" && !this.cinema_vouchers.length) {
        console.log("its run opencinemamodal");
        this.cinema_vouchers.push({
          // cinemaList: this.cinemas,
          cine_name: {},
          screen_name: [],
          seat_class: [],
          ticket_name: [],
          cinemaScreen: [],
          cinemaScreenSeats: [],
          cinemaScreenTickets: [],
        });
        this.$forceUpdate();
      } else {
        console.log("its run opencinemamodal else");
        this.cinema_vouchers = [];
        if (this.currentVoucherData.promo_cinema_settings.length) {
          let filteredCinemas =
            this.currentVoucherData.promo_cinema_settings.filter(
              (cinemaObj) => {
                return cinemaObj.pvcs_is_active == "Y";
              }
            );

          filteredCinemas.forEach((filteredCinemaObj) => {
            return (filteredCinemaObj["pvcs_is_active"] = "N");
          });

          this.voucherUpdateData.inactivePromoCinemaFields = [
            ...filteredCinemas,
          ];
        }
      }
    },
    getMovieFormats: function () {
      let payload = {
        tableName: "ms_movie_formats",
        mf_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.movieFormats = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getScreensSeats: async function (
      type,
      index,
      array = this.cinema_vouchers
    ) {
      console.log({ type, index, array });
      try {
        if (!array[index].cine_name) {
          this.cinema_vouchers.splice(index, 1);
          return;
        }
        let payload = {
          cinema_id: array[index].cine_name.cine_id || null,
        };
        if (array[index].screen_name.length) {
          console.log(payload["screen_id"], array[index].screen_name, "test");
          payload["screen_id"] = array[index].screen_name.map(
            (screen) => screen.screen_id
          );
          payload["cinema_id"] = array[index].cine_name.cine_id || null;
        }
        const response = await MarketingService.getCinemaScreenSeats(payload);
        const { data } = response;
        if (data.status && data.Records.length) {
          if (type == "cinema_id") {
            // only update screens options if cinema changed
            array[index]["cinemaScreen"] = [...data.screenRecords];
            console.log(data.screenRecords, "from screenRecords");
            // this.cinema_vouchers[index]["screen_name"] = [];
            // this.cinema_vouchers[index]["seat_class"] = [];
            // this.cinema_vouchers[index]["ticket_name"] = [];
          }
          array[index]["cinemaScreenSeats"] = [...data.Records];
          this.getScreenTicketTypes("screen_id", index, array);
        }
      } catch (error) {
        console.log(error, "screen_seat");
      }
    },
    getScreenTicketTypes: function (type, index, array = this.cinema_vouchers) {
      this.screenTickets = [];

      let selectedScreen = array[index]["screen_name"];
      console.log(index, selectedScreen);

      selectedScreen.forEach((screen) => {
        let obj = {
          screen_id: screen.screen_id,
          screen_name: `${screen.screen_name}`,
          ticketsData: this.tickets.map((ticket) => ({
            tt_id: `${screen.screen_id}-${ticket.tt_id}`,
            tt_name: ticket.tt_name,
            screen_id: screen.screen_id,
            screen_name: screen.screen_name,
          })),
        };
        array[index]["cinemaScreenTickets"].push(obj);
      });
    },
    addCinemaVouchers: function () {
      // let selectedCinemaArr = this.cinema_vouchers.map((cinemasObj) =>
      //   String(cinemasObj.cine_name.cine_id)
      // );
      this.cinema_vouchers.push({
        // cinemaList: this.cinemas.filter(
        //   (cinemas) => !selectedCinemaArr.includes(String(cinemas.cine_id))
        // ),
        cine_name: {},
        screen_name: [],
        seat_class: [],
        ticket_name: [],
        cinemaScreen: [],
        cinemaScreenSeats: [],
        cinemaScreenTickets: [],
      });
    },
    removeCinemaVouchers: function (index) {
      let filteredCinemaArr =
        this.currentVoucherData.promo_cinema_settings.filter((cinemasObj) => {
          return (
            cinemasObj.cinema_id ==
              this.cinema_vouchers[index].cine_name.cine_id &&
            cinemasObj.pvcs_is_active == "Y"
          );
        });

      if (filteredCinemaArr.length) {
        filteredCinemaArr.forEach((filteredCinemaObj) => {
          filteredCinemaObj["pvcs_is_active"] = "N";
          this.voucherUpdateData.inactivePromoCinemaFields.push(
            filteredCinemaObj
          );
        });
      }
      this.cinema_vouchers.splice(index, 1);
    },
    getMovies: async function () {
      try {
        this.movies = [];
        const response = await MovieService.GetActiveMoviesWithFormat({
          movieversions: "Y",
        });
        const { data } = response;
        if (data.status && data.Records.length) {
          this.movies = [
            {
              label: "Select All Movies",
              Movies: data.Records,
            },
          ];
        } else {
          this.$toasted.show(data.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
    handleSequenceClick: function (event) {
      this.voucher_multiple_codes.is_random =
        !this.voucher_multiple_codes.is_random;
      this.voucher_multiple_codes.is_sequence =
        !!this.voucher_multiple_codes.is_random;
    },
    onChangeVoucherSettings: function (type, event) {
      console.log({ event });
      if (type == "voucher_code_required" && event == "N") {
        this.voucher_multiple_codes = {
          is_required: false,
          no_of_vouchers: 10,
          prefix_text: "",
          is_random: true,
          is_sequence: false,
          voucher_code_length: 8,
          sequence_start: 1,
        };
      } else if (type == "is_open") {
        if (event == "N") {
          this.voucher_settings.is_complimentary = "N";
          this.voucher_settings.ticket_type_selected = null;
          this.voucher_settings.selected_complimentary_cinema = null;
        } else {
          this.voucher_config.value_voucher = "N";
          this.voucher_config.voucher_amount = null;
          this.voucher_config.min_ticket_amount = null;
          this.voucher_config.voucher_max_redemption_amount = null;
        }
      }
    },
    onChangeVoucherConfig: function (type, event) {
      console.log({ event });
      if (type == "value_voucher") {
        if (event == "N") {
          this.voucher_config.redeem_at_fnb = "N";
          this.voucher_config.voucher_amount = null;
          this.voucher_config.voucher_max_redemption_amount = null;
          this.voucher_config.min_ticket_amount = null;
        } else {
          this.voucher_config.voucher_buy_no_of_ticket = null;
          this.voucher_config.voucher_get_free_ticket = null;
          this.voucher_config.voucher_max_redemption_amount = null;
          this.voucher_config.voucher_is_percentage = "Y";
        }
      }
    },
    getTicketTypeList: async function () {
      try {
        let body = {
          tableName: "ms_ticket_type",
        };
        const response = await MasterService.GetActiveList(body);
        const { data } = response;
        if (data.status && data.Records.length) {
          this.tickets = [
            ...data.Records.filter((ticket) => {
              return ticket.tt_is_active == "Y";
            }),
          ];
          this.ticketsForDist = [
            ...data.Records.filter((ticket) => {
              return ticket.tt_is_active == "Y";
            }),
          ];
        } else {
          this.$toasted.show(data.message);
        }
      } catch (error) {
        console.log(error, "ticket_list");
      }
    },
    getScreenList: async function (event, index = null) {
      try {
        let payload = {
          cinema_id: event.cine_id,
        };
        const response = await scheduleService.GetScreens(payload);
        const { data } = response;
        if (data.status && data.Records.length) {
          this.screensByCinema = [
            ...data.Records.filter(
              (screen) => screen.screen_seat_types.length > 0
            ),
          ];
        }
      } catch (error) {
        console.log(error);
      }
    },
    saveCinemaScreensArray: async function (
      event,
      index,
      array = this.cinema_vouchers
    ) {
      try {
        let payload = {
          cinema_id: event.cine_id,
        };
        const response = await scheduleService.GetScreens(payload);
        const { data } = response;
        if (data.status && data.Records.length) {
          array[index]["cinemaScreen"] = data.Records.filter(
            (screen) => screen.screen_seat_types.length > 0
          ).map((screensObj) => ({
            screen_name: screensObj.screen_name,
            screen_id: screensObj.screen_id.toString(),
          }));
          // this.screensByCinema = [
          // ...data.Records.filter(
          //   (screen) => screen.screen_seat_types.length > 0
          // ),
          // ];
        }
      } catch (error) {
        console.log(error);
      }
    },
    removeSreenBasedSeats(type, index, event) {
      console.log({ type, index, event }, "remove Data");
      if (type == "cinema_id") {
        // let filteredCinemaData = this.currentVoucherData.promo_cinema_settings.filter(
        //   (cinemaObj) => {
        //     return (cinemaObj.pvcs_is_active =
        //       "Y" && String(cinemaObj.cinema_id) == String(event.cine_id));
        //   }
        // );

        // if (filteredCinemaData.length) {
        //   filteredCinemaData.forEach((filteredCinemaObj) => {
        //     filteredCinemaObj["pvcs_is_active"] = "N";
        //   });

        //   this.voucherUpdateData.inactivePromoCinemaFields = [
        //     ...filteredCinemaData,
        //   ];
        // }

        this.cinema_vouchers[index]["screen_name"] = [];
        this.cinema_vouchers[index]["seat_class"] = [];
        this.cinema_vouchers[index]["ticket_name"] = [];
      } else if (type == "screen_id") {
        let seatsClass = this.cinema_vouchers[index]["seat_class"];
        let ticketClass = this.cinema_vouchers[index]["ticket_name"];

        // let filteredScreenData = this.currentVoucherData.promo_cinema_settings.filter(
        //   (screenObj) => {
        //     return (
        //       screenObj.pvcs_is_active == "Y" &&
        //       String(screenObj.screen_id) == String(event.screen_id)
        //     );
        //   }
        // );

        // if (filteredScreenData.length) {
        //   filteredScreenData.forEach((filteredScreenObj) => {
        //     filteredScreenObj["pvcs_is_active"] = "N";
        //   });
        //   this.voucherUpdateData.inactivePromoCinemaFields = [
        //     ...this.voucherUpdateData.inactivePromoCinemaFields,
        //     ...filteredScreenData,
        //   ];
        // }

        this.cinema_vouchers[index]["seat_class"] = seatsClass.filter(
          (seatsObj) => {
            return String(seatsObj.screen_id) != String(event.screen_id);
          }
        );
        this.cinema_vouchers[index]["ticket_name"] = ticketClass.filter(
          (ticketsObj) => {
            return String(ticketsObj.screen_id) != String(event.screen_id);
          }
        );
      }
    },
    onChangeValueVoucher: function (event) {
      this.voucher_config.voucher_amount = 0;
      this.voucher_config.voucher_buy_no_of_ticket = 0;
      this.voucher_config.voucher_get_free_ticket = 0;
      this.voucher_config.is_bogo_voucher = "bogo_voucher";
      if (event == "N") {
        this.voucher_config.redeem_at_fnb = false;
      }
    },
    onChangeWeekdays: function (event, keyname) {
      // console.log("event :", event);
      if (keyname !== "selectAll") {
        this.weekDays["selectAll"] = false;
      }
      let len = Object.keys(this.weekDays).length;
      if (keyname === "selectAll" && event) {
        Object.keys(this.weekDays).map((x) => {
          x !== "selectAll" ? (this.weekDays[x] = true) : "";
        });
      } else if (keyname === "selectAll" && !event) {
        Object.keys(this.weekDays).map((x) => {
          x !== "selectAll" ? (this.weekDays[x] = false) : "";
        });
      } else if (keyname !== "selectAll" && this.weekDays.selectAll) {
        this.weekDays["selectAll"] = false;
      }
    },
    getClients: async function () {
      try {
        const response = await ClientService.GetAllClients({});
        const { data } = response;
        if (data && data.status && data.Records.length) {
          this.clients = [...data.Records];
        } else {
          this.$toasted.show(data.message);
        }
      } catch (error) {
        console.log(error, "client error");
      }
    },
    getArrMaxLength(maxLength = 0, maxLengthArr) {
      if (maxLengthArr.length) {
        maxLengthArr.forEach((arr_elem, index) => {
          if (arr_elem > maxLengthArr[maxLength]) {
            maxLength = index;
          }
        });
      }
      return maxLength;
    },
    onRemoveHandler(type, event, index) {
      console.log({ type, event, index });
      if (type == "seats") {
        let seatIndex = this.currentVoucherData.promo_cinema_settings.findIndex(
          (seatsObj) => {
            return (
              seatsObj.pvcs_is_active == "Y" &&
              String(seatsObj.seat_type_id) == String(event.sst_id)
            );
          }
        );

        if (seatIndex >= 0) {
          let inactiveObj =
            this.currentVoucherData.promo_cinema_settings[seatIndex];
          inactiveObj["pvcs_is_active"] = "N";
          this.voucherUpdateData.inactivePromoCinemaFields.push(inactiveObj);
        }
      } else if (type == "ticket_name") {
        let ticketIndex =
          this.currentVoucherData.promo_cinema_settings.findIndex((tickets) => {
            return (
              tickets.pvcs_is_active == "Y" &&
              String(tickets.tt_id) == String(event.tt_id.split("-")[1]) &&
              event.screen_id == tickets.screen_id
            );
          });

        if (ticketIndex >= 0) {
          let inactiveObj =
            this.currentVoucherData.promo_cinema_settings[ticketIndex];
          inactiveObj["pvcs_is_active"] = "N";
          this.voucherUpdateData.inactivePromoCinemaFields.push(inactiveObj);
        }
      } else if (type == "movie_name") {
        let movieIndex = this.currentVoucherData.promo_movie_settings.findIndex(
          (movieObj) => {
            console.log(
              movieObj.md_id,
              event.md_id,
              movieObj.pvms_is_active,
              "from movie"
            );
            return (
              String(movieObj.md_id) == String(event.md_id) &&
              movieObj.pvms_is_active == "Y"
            );
          }
        );

        console.log({ movieIndex });

        if (movieIndex >= 0) {
          this.currentVoucherData.promo_movie_settings[movieIndex][
            "pvms_is_active"
          ] = "N";
          this.voucherUpdateData.inactiveMovieFields.push(
            this.currentVoucherData.promo_movie_settings[movieIndex]
          );
        }
      } else if (type == "only_cinemas") {
        let cinemaIndex =
          this.currentVoucherData.promo_cinema_settings.findIndex(
            (cinemaObj) => {
              return cinemaObj.cinema_id == event.cinema_id;
            }
          );

        if (cinemaIndex >= 0) {
          this.currentVoucherData.promo_cinema_settings[cinemaIndex][
            "pvcs_is_active"
          ] = "N";
          this.voucherUpdateData.inactivePromoCinemaFields.push(
            this.currentVoucherData.promo_cinema_settings[cinemaIndex]
          );
        }
      }
    },
    makeCinemaVouchersArrOld: function (cinemaVouchersArr) {
      if (!cinemaVouchersArr.length) return;
      let finalCinemaVouchersArr = [];
      cinemaVouchersArr.forEach(async (cinemasObj) => {
        let cinemaIndex = finalCinemaVouchersArr.findIndex((voucherIndex) => {
          return voucherIndex.cine_name.cine_id == cinemasObj.cinema_id;
        });

        if (cinemaIndex < 0) {
          console.log(cinemaVouchersArr, finalCinemaVouchersArr);
          let voucherCinemaSettings = cinemaVouchersArr.filter(
            (cinemaVoucherObj) => {
              return cinemaVoucherObj.cinema_id == cinemasObj.cinema_id;
            }
          );
          // let selectedCinemaArr = finalCine.map((cinemasObj) =>
          //   String(cinemasObj.cine_name.cine_id)
          // );
          let screensArr = voucherCinemaSettings.filter((screensObj) => {
            return screensObj.screen_id;
          });
          finalCinemaVouchersArr.push({
            // cinemaList: this.cinemas.filter(
            //   (cinemas) => !selectedCinemaArr.includes(String(cinemas.cine_id))
            // ),
            cine_name: {
              cine_id: cinemasObj.cinema_id,
              cine_name: cinemasObj.cine_name,
            },
            screen_name: screensArr.length
              ? uniqBy(screensArr, (screensObj) => screensObj.screen_id)
              : [],
            seat_class: voucherCinemaSettings
              .filter((filterSeatsObj) => {
                return filterSeatsObj.seat_type_id;
              })
              .map((seatsObj) => ({
                pvcs_id: seatsObj.pvcs_id,
                sst_id: seatsObj.seat_type_id,
                sst_seat_type: seatsObj.sst_seat_type,
                screen_id: seatsObj.screen_id,
                screen_name: seatsObj.screen_name,
              })),
            ticket_name: voucherCinemaSettings
              .filter((filterTicktetsObj) => {
                return filterTicktetsObj.tt_id;
              })
              .map((ticketsObj) => ({
                pvcs_id: ticketsObj.pvcs_id,
                tt_id: `${ticketsObj.screen_id}-${ticketsObj.tt_id}`,
                tt_name: ticketsObj.tt_name,
                screen_id: ticketsObj.screen_id,
                screen_name: ticketsObj.screen_name,
              })),
          });
          await this.getScreensSeats(
            "cinema_id",
            finalCinemaVouchersArr.length - 1,
            finalCinemaVouchersArr
          );
          await this.getScreensSeats(
            "screen_id",
            finalCinemaVouchersArr.length - 1,
            finalCinemaVouchersArr
          );
        }
      });

      return finalCinemaVouchersArr;
    },
    makeCinemaVouchersArr: async function (cinemaVouchersArr) {
      let finalCinemaVouchersArr = [];

      for await (const cinemaObj of cinemaVouchersArr) {
        let cinemaIndex = finalCinemaVouchersArr.findIndex(
          (currentCinemaObj) => {
            return currentCinemaObj.cine_name.cine_id == cinemaObj.cinema_id;
          }
        );

        if (cinemaIndex < 0) {
          let filteredScreens = cinemaVouchersArr.filter(
            (filteredScreenObj) => {
              return (
                filteredScreenObj.cinema_id == cinemaObj.cinema_id &&
                filteredScreenObj.screen_id
              );
            }
          );

          let filteredTickets = cinemaVouchersArr.filter(
            (filteredTicketObj) => {
              return (
                filteredTicketObj.cinema_id == cinemaObj.cinema_id &&
                filteredTicketObj.all_tt_id
              );
            }
          );

          let filteredSeats = cinemaVouchersArr.filter((filteredSeatObj) => {
            return (
              filteredSeatObj.cinema_id == cinemaObj.cinema_id &&
              filteredSeatObj.seat_type_id
            );
          });

          // screen arr to filter and push the pvcs_id
          let screenArr = [];
          if (filteredScreens.length) {
            filteredScreens.forEach((screensObj) => {
              let screenIndex = screenArr.findIndex((currentScreenIndex) => {
                return currentScreenIndex.screen_id == screensObj.screen_id;
              });

              if (screenIndex < 0) {
                screenArr.push({
                  ...screensObj,
                  screen_id: String(screensObj.screen_id),
                  all_pvcs_id: [screensObj.pvcs_id],
                });
              } else {
                screenArr[screenIndex]["all_pvcs_id"].push(screensObj.pvcs_id);
              }
            });
          }
          // screen arr to filter and push the pvcs_id

          // ticket arr to filter and push the pvcs_id
          let ticketArr = [];
          if (filteredTickets.length) {
            filteredTickets.forEach((ticketsObj) => {
              let splitTicketsValue = ticketsObj.all_tt_id.split(",");

              splitTicketsValue.forEach((splitTicketObj) => {
                let ticketIndex = ticketArr.findIndex((currentTicketIndex) => {
                  return (
                    currentTicketIndex.tt_id ==
                    `${ticketsObj.screen_id}-${splitTicketObj}`
                  );
                });

                if (ticketIndex < 0) {
                  ticketArr.push({
                    tt_id: `${ticketsObj.screen_id}-${splitTicketObj}`,
                    screen_id: ticketsObj.screen_id,
                    screen_name: ticketsObj.screen_name,
                    all_pvcs_id: [ticketsObj.pvcs_id],
                    tt_name: this.tickets.filter((ticket) => {
                      console.log({ splitTicketObj }, ticket, ticket.tt_id);
                      return ticket.tt_id == splitTicketObj;
                    })[0].tt_name,
                  });
                } else {
                  ticketArr[ticketIndex]["all_pvcs_id"].push(
                    ticketsObj.pvcs_id
                  );
                }
              });
            });
          }
          // ticket arr to filter and push the pvcs_id

          let seatsArr = [];
          if (filteredSeats.length) {
            seatsArr = filteredSeats.map((seatObj) => ({
              screen_id: seatObj.screen_id,
              sst_id: seatObj.seat_type_id,
              screen_name: seatObj.screen_name,
              sst_seat_type: seatObj.sst_seat_type,
              pvcs_id: seatObj.pvcs_id,
            }));
          }

          let obj = {
            cine_name: {
              cine_id: cinemaObj.cinema_id,
              cine_name: cinemaObj.cine_name,
            },
            screen_name: screenArr,
            seat_class: seatsArr,
            ticket_name: ticketArr,
            cinemaScreen: [],
            cinemaScreenSeats: [],
            cinemaScreenTickets: [],
          };

          finalCinemaVouchersArr.push(obj);
          this.cinema_vouchers.push(obj);

          await this.getScreensSeats(
            "cinema_id",
            this.cinema_vouchers.length - 1,
            this.cinema_vouchers
          );

          await this.saveCinemaScreensArray(
            { cine_id: cinemaObj.cinema_id },
            this.cinema_vouchers.length - 1,
            this.cinema_vouchers
          );

          // await this.getScreensSeats(
          //   "screen_id",
          //   this.cinema_vouchers.length - 1,
          //   this.cinema_vouchers
          // );
        }
      }

      // return finalCinemaVouchersArr;
    },
    getAllScreenSeatsForDistShares: async function () {
      try {
        let payload = { isCinemaCode: true };
        const response = await MarketingService.getCinemaScreenSeats(payload);
        const { data } = response;
        if (data.status && data.Records.length) {
          this.seatTypesListForDist = data.Records;
          if (this.voucherDistShareValues.length) {
            this.distShareValues = [];
            this.voucherDistShareValues.map((shareValuesObj) => {
              let distIndex = this.distShareValues.findIndex((distObj) => {
                return distObj.dist_value == shareValuesObj.pvds_dist_value;
              });
              if (distIndex < 0) {
                let ticketFilteredData = [];
                if (shareValuesObj.pvds_ticket_type_id) {
                  let ticketData = String(
                    shareValuesObj.pvds_ticket_type_id
                  ).split(",");
                  ticketFilteredData = this.ticketsForDist.filter(
                    (ticketObj) => {
                      return ticketData.includes(String(ticketObj.tt_id));
                    }
                  );
                }
                let obj = {
                  seat_type_id: [
                    {
                      screen_id: shareValuesObj.pvds_screen_id,
                      sst_id: shareValuesObj.pvds_seat_type_id,
                      sst_seat_type: shareValuesObj.sst_seat_type,
                      screen_name: shareValuesObj.screen_name,
                    },
                  ],
                  ticket_type_id: ticketFilteredData.length
                    ? ticketFilteredData
                    : [],
                  dist_value: shareValuesObj.pvds_dist_value,
                };
                this.distShareValues.push(obj);
              } else {
                this.distShareValues[distIndex]["seat_type_id"].push({
                  screen_id: shareValuesObj.pvds_screen_id,
                  sst_id: shareValuesObj.pvds_seat_type_id,
                  sst_seat_type: shareValuesObj.sst_seat_type,
                  screen_name: shareValuesObj.screen_name,
                });
              }
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    getVoucherData: async function () {
      let loader = this.$loading.show();
      try {
        let payload = { voucher_id: this.currentVoucherId };
        const response = await MarketingService.getVouchersV2(payload);
        const { data } = response;
        if (!data.status) {
          loader.hide();
          return this.$toasted.show("Something went wrong");
        }
        const {
          vouchers = {},
          promo_cinemas = [],
          promo_movies = [],
          voucher_dist_values = [],
        } = data;
        console.log({ vouchers });
        this.currentVoucherData.vouchers = vouchers;
        this.voucher_code = vouchers.voucher_code;
        this.voucher_name = vouchers.voucher_title;
        this.voucher_receipt_print = vouchers.voucher_receipt_name;
        this.voucher_is_active = vouchers.voucher_is_active;
        this.voucher_terms = vouchers.voucher_terms;
        this.is_foreign_movie_applicable = vouchers.is_foreign_movie_applicable;
        this.offer_dist_share_threshold = vouchers.offer_dist_share_threshold
          ? vouchers.offer_dist_share_threshold
          : 0;

        this.voucher_split = {
          client: vouchers.client_id
            ? {
                client_id: vouchers.client_id,
                client_name: vouchers.client_name,
              }
            : null,
          share_value: vouchers.client_share_value,
          share_is_percentage: vouchers.client_share_is_percentage,
        };
        // this.cinema_specific_voucher = promo_cinemas.length > 0 ? "Y" : "N";
        //   this.cinema_vouchers='empty'
        // this.voucher_specific_cinemas =[];
        //   this.voucher_movies.is_applicable='empty'
        this.vouchers_used_for = vouchers.voucher_description;
        // voucher start end time
        this.voucher_date_time = {
          voucher_start_date: vouchers.voucher_start_date_time,
          voucher_end_date: vouchers.voucher_end_date_time,
          voucher_start_time: vouchers.voucher_start_time,
          voucher_end_time: vouchers.voucher_end_time,
        };
        // voucher start end time

        // on net/gross
        this.voucher_config.voucher_redemption_on =
          vouchers.voucher_redeem_on_net
            ? "voucher_redeem_on_net"
            : "voucherRedeemGrossAmount";
        // on net/gross

        this.voucher_movies.is_applicable =
          vouchers.is_movie_applicable == "Y"
            ? "movies_applicable"
            : "movies_not_applicable";

        this.voucher_settings = {
          is_code_required: vouchers.is_code_required,
          is_open: vouchers.is_open_voucher,
          is_complimentary: vouchers.is_complemetory_ticket,
          is_allow_cash_refund: vouchers.allow_cash_refund,
          share_with_dist: vouchers.is_share_with_distributor,
          add_in_revenue: vouchers.add_in_revenue,
          ticket_type_selected: {
            tt_name: vouchers.tt_id
              ? this.tickets.filter(
                  (ticketObj) => ticketObj.tt_id == vouchers.tt_id
                )[0].tt_name
              : "",
            tt_id: vouchers.tt_id,
          },
          selected_complimentary_cinema: {
            cine_name: null,
            cine_id: vouchers.cinema_id,
          },
          selected_complimentary_screen: {
            screen_name: null,
            screen_id: vouchers.screen_id,
          },
          is_web_rate_card: vouchers.is_web_rate_card,
          vs_movie_mf_id: vouchers.vs_movie_mf_id,
          is_redemptions: vouchers.is_redemption || "N",
          has_v_reporting_percent: vouchers.has_v_reporting_percent || "N",
          v_reporting_percent: vouchers.v_reporting_percent || null,
        };
        if (vouchers.cinema_id) {
          await this.getCinemas();
          await this.getScreenList({ cine_id: vouchers.cinema_id });
          this.voucher_settings["selected_complimentary_cinema"] = {
            cine_name:
              this.cinemas.filter(
                (cinemas) => cinemas.cine_id == vouchers.cinema_id
              )[0].cine_name || "",
            cine_id: vouchers.cinema_id,
          };

          this.voucher_settings["selected_complimentary_screen"] = {
            screen_name: vouchers.screen_id
              ? this.screensByCinema.filter(
                  (screen) => screen.screen_id == vouchers.screen_id
                )[0].screen_name
              : "",
            screen_id: vouchers.screen_id,
          };
        }
        Object.keys(this.weekDays).map((day, index) => {
          if (!index) return;

          this.weekDays[day] = vouchers[`pvds_${day}`] == "Y";
        });

        let checkAllDaysSelected = Object.keys(this.weekDays).filter((day) => {
          return this.weekDays[day] == "N";
        }).length;

        if (checkAllDaysSelected) this.weekDays.selectAll = false;

        this.voucher_config = {
          redeem_at_box: vouchers.vs_redeem_at_boxoffice == "Y",
          redeem_at_fnb: vouchers.vs_redeem_at_concession == "Y",
          redeem_at_online: vouchers.vs_redeem_at_online == "Y",
          value_voucher: vouchers.is_voucher_type_value,
          voucher_buy_no_of_ticket: vouchers.voucher_buy_no_of_ticket,
          voucher_get_free_ticket: vouchers.voucher_get_free_ticket,
          min_ticket_amount: vouchers.voucher_min_redemption_amount,
          voucher_max_redemption_amount: vouchers.voucher_max_redemption_amount,
          voucher_amount: vouchers.voucher_amount,
          voucher_is_percentage: vouchers.voucher_is_percentage,
          voucher_redemption_on: vouchers.voucher_redeem_on_gross
            ? "voucherRedeemGrossAmount"
            : "voucherRedeemNetAmount",
          is_bogo_voucher:
            vouchers.voucher_type_id == 3
              ? "is_not_bogo_voucher"
              : "bogo_voucher",
          voucher_redemption_per_patron: vouchers.voucher_redemption_per_patron,
          voucher_total_redemption: vouchers.voucher_total_redemption,
          voucher_redemption_percent_fnb:
            vouchers.voucher_redemption_percent_fnb,
        };

        this.currentVoucherData.promo_cinema_settings = [...promo_cinemas];
        this.currentVoucherData.promo_movie_settings = [...promo_movies];
        this.currentVoucherData.vs_settings = {
          vs_applicable_for_prebook: vouchers.vs_applicable_for_prebook,
          vs_applicable_for_normal: vouchers.vs_applicable_for_normal,
          vs_partner_id: null,
          vs_cinema_based: vouchers.vs_cinema_based,
          vs_movie_based: vouchers.vs_movie_based,
          vs_class_based: vouchers.vs_class_based,
          vs_screen_based: vouchers.vs_screen_based,
          vs_day_based: vouchers.vs_day_based,
          vs_redeem_at_boxoffice: vouchers.vs_redeem_at_boxoffice,
          vs_redeem_at_concession: vouchers.vs_redeem_at_concession,
          vs_redeem_at_online: vouchers.vs_redeem_at_online,
          vs_is_active: "Y",
        };

        if (promo_cinemas.length) {
          // let isScreenTypeExist=promo_cinemas.some(cinemasObj=>{
          //   return cinemasObj.screen_id
          // })
          let isScreenBased = promo_cinemas.some((screensObj) => {
            return screensObj.screen_id;
          });
          if (isScreenBased) {
            await this.makeCinemaVouchersArr(promo_cinemas);
          } else {
            this.voucher_specific_cinemas = promo_cinemas.map((cinemas) => ({
              cine_id: cinemas.cinema_id,
              cine_name: cinemas.cine_name,
            }));
          }
        }

        if (vouchers.voucher_type_id == 3) {
        }

        this.cinema_specific_voucher =
          this.cinema_vouchers && this.cinema_vouchers.length ? "Y" : "N";
        // this.cinema_vouhers.forEach(screenSeats=>{})
        // this.voucher_specific_cinemas =
        //   this.cinema_specific_voucher == "N" ? [...promo_cinemas] : [];

        if (vouchers.vs_movie_mf_id) {
          let mfArr = vouchers.vs_movie_mf_id
            .split(",")
            .map((mf) => String(mf));
          this.selectedMovieFormats = this.movieFormats.filter((mfObj) => {
            return mfArr.includes(String(mfObj.mf_id));
          });
        }

        if (promo_movies.length) {
          this.selectedMovies = promo_movies;
        }

        if (voucher_dist_values.length) {
          this.voucherDistShareValues = [...voucher_dist_values];
        }

        loader.hide();
      } catch (error) {
        console.log(error);
      }
    },
    makeUpdatePromotionVoucherArr(array = this.cinema_vouchers) {
      let finalCinemaVouchersArr = [];

      array.forEach((cinemaObj) => {
        let screenIdArr = [];
        if (cinemaObj.screen_name.length) {
          if (cinemaObj.seat_class.length) {
            cinemaObj.seat_class.forEach((seatsObj) => {
              let ticketFilteredArr = [];
              screenIdArr.push(String(seatsObj.screen_id));
              if (cinemaObj.ticket_name.length) {
                ticketFilteredArr = cinemaObj.ticket_name.filter(
                  (ticketsObj) => {
                    return ticketsObj.screen_id == seatsObj.screen_id;
                  }
                );
              }
              let tempSeatsObj = {
                cinema_id: cinemaObj.cine_name.cine_id,
                screen_id: String(seatsObj.screen_id),
                seat_type_id: seatsObj.sst_id,
                tt_id: null,
                all_tt_id: ticketFilteredArr.map((filteredTicketsObj) =>
                  filteredTicketsObj.tt_id.split("-").pop()
                ),
              };
              finalCinemaVouchersArr.push(tempSeatsObj);
            });
          }

          if (cinemaObj.ticket_name.length) {
            cinemaObj.ticket_name.forEach((ticketObj) => {
              let screenIndex = finalCinemaVouchersArr.findIndex(
                (currentScreenObj) => {
                  return currentScreenObj.screen_id == ticketObj.screen_id;
                }
              );

              if (screenIndex < 0) {
                screenIdArr.push(String(ticketObj.screen_id));
                let tempTicketObj = {
                  cinema_id: cinemaObj.cine_name.cine_id,
                  screen_id: String(ticketObj.screen_id),
                  seat_type_id: null,
                  tt_id: null,
                  all_tt_id: cinemaObj.ticket_name
                    .filter((filteredTicketObj) => {
                      return filteredTicketObj.screen_id == ticketObj.screen_id;
                    })
                    .map((filteredOutTicketObj) =>
                      filteredOutTicketObj.tt_id.split("-").pop()
                    ),
                };
                finalCinemaVouchersArr.push(tempTicketObj);
              }
            });
          }

          let remainingScreenArr = cinemaObj.screen_name.filter((screenObj) => {
            return !screenIdArr.includes(String(screenObj.screen_id));
          });

          if (remainingScreenArr.length) {
            remainingScreenArr.forEach((screenObj) => {
              let tempScreenObj = {
                cinema_id: cinemaObj.cine_name.cine_id,
                screen_id: String(screenObj.screen_id),
                seat_type_id: null,
                tt_id: null,
                all_tt_id: [],
              };
              finalCinemaVouchersArr.push(tempScreenObj);
            });
          }

          // insert seat types to corressponding screen seat objects
          // if (cinemaObj.seat_class.length) {
          //   cinemaObj.seat_class.forEach((seatsObj) => {
          //     let seatIndex = finalCinemaVouchersArr.findIndex(
          //       (currentSeatIndex) => {
          //         return currentSeatIndex.screen_id == seatsObj.screen_id;
          //       }
          //     );

          //     finalCinemaVouchersArr[seatIndex]["seat_type_id"] =
          //       seatsObj.sst_id;
          //   });
          // }

          // insert ticket types to corressponding screen objects
        } else {
          finalCinemaVouchersArr.push({
            cinema_id: cinemaObj.cine_name.cine_id,
            screen_id: null,
            seat_type_id: null,
            tt_id: null,
            all_tt_id: [],
          });
        }
      });
      console.log({ finalCinemaVouchersArr });
      return finalCinemaVouchersArr;
    },
    onSubmitUpdateData: async function () {
      try {
        if (
          !this.weekDays.selectAll &&
          Object.keys(this.weekDays).filter(
            (x) => x !== "selectAll" && this.weekDays[x]
          ).length === 0
        ) {
          this.custom_errors.weekday_errors = "Please select atleast one day";
          return;
        } else {
          this.custom_errors.weekday_errors = "";
        }

        if (
          !this.cinema_vouchers.length &&
          !this.voucher_specific_cinemas.length
        ) {
          this.custom_errors.only_cinema_error = "Please select a cinema";
          return this.$toasted.show("Please select a cinema");
        } else {
          this.custom_errors.only_cinema_error = "";
        }

        if (!this.voucher_date_time.voucher_start_date) {
          this.$toasted.show("Please select voucher start date");
          this.custom_errors.voucher_start_date_error =
            "Please select voucher start date";
          return;
        }

        // free tickets count validation
        if (
          this.voucher_config.value_voucher == "N" &&
          this.showConfiguration &&
          this.voucher_config.voucher_max_redemption_amount <
            this.voucher_config.voucher_get_free_ticket &&
          this.voucher_config.is_bogo_voucher == "bogo_voucher"
        ) {
          return this.$toasted.show(
            "Maximum free tickets must be greater or equals to offer free tickets"
          );
        }
        // free tickets count validation

        // complimentary tickets validation
        if (
          this.voucher_settings.is_complimentary == "Y" &&
          !this.voucher_settings.ticket_type_selected
        ) {
          return this.$toasted.show("Select complimentary ticket type");
        }
        // complimentary tickets validation

        // open voucher validation
        if (
          this.voucher_settings.is_open == "N" &&
          this.voucher_settings.is_complimentary == "Y"
        ) {
          this.voucher_settings.allow_cash_refund = "N";
        }
        // open voucher validation

        // value voucher configuration
        if (this.voucher_config.value_voucher == "N") {
          this.voucher_config.voucher_is_percentage = "N";
        }
        // value voucher configuration

        // voucher start and end date time validation
        this.voucher_date_time.voucher_start_time = moment(
          this.voucher_date_time.voucher_start_time,
          "HH:mm"
        ).isValid()
          ? this.voucher_date_time.voucher_start_time
          : "00:00";
        let voucherStartDate = this.convertTime(
          this.voucher_date_time.voucher_start_date,
          this.voucher_date_time.voucher_start_time
        );
        let voucherEndDate = null;

        this.voucher_date_time.voucher_end_time = moment(
          this.voucher_date_time.voucher_end_time,
          "HH:mm"
        ).isValid()
          ? this.voucher_date_time.voucher_end_time
          : "23:59";
        if (this.voucher_date_time.voucher_end_date) {
          voucherEndDate = this.convertTime(
            this.voucher_date_time.voucher_end_date,
            this.voucher_date_time.voucher_end_time
          );
        }

        if (!this.voucher_date_time.voucher_end_date) {
  this.$toasted.show("Please select voucher end date");
  this.custom_errors.voucher_end_date_error = "Please select voucher end date";
  return;
}

        if (voucherStartDate && voucherEndDate) {
          if (voucherEndDate < voucherStartDate) {
            return this.$toasted.show("End Date less than Start Date");
          } else if (voucherStartDate > voucherEndDate) {
            return this.$toasted.show("Start Date greater than End Date");
          }
        }

        if (
          this.voucher_movies.is_applicable == "movies_not_applicable" &&
          !this.selectedMovieFormats.length
        ) {
          return this.$toasted.show(
            "Please select atleast one applicable movie format"
          );
        }
        // voucher start and end date time validation
        const test = await this.$validator;
        const valid = await this.$validator.validate();
        console.log({ valid, test });
        if (!valid) return;

        let voucher_overall_settings = {
          vs_applicable_for_prebook: "Y",
          vs_applicable_for_normal: "Y",
          vs_partner_id: null,
          vs_cinema_based:
            (this.cinema_vouchers.length &&
              this.cinema_vouchers[0]["cine_name"]["cine_id"]) ||
            this.voucher_specific_cinemas.length
              ? "Y"
              : "N",
          vs_movie_based: this.selectedMovies.length ? "Y" : "N",
          vs_class_based: "N",
          vs_screen_based: "N",
          vs_day_based: "Y",
          vs_redeem_at_boxoffice: this.voucher_config.redeem_at_box ? "Y" : "N",
          vs_redeem_at_concession: this.voucher_config.redeem_at_fnb
            ? "Y"
            : "N",
          is_movie_applicable:
            this.voucher_movies.is_applicable == "movies_applicable"
              ? "Y"
              : "N",
          vs_redeem_at_online: this.voucher_config.redeem_at_online ? "Y" : "N",
          vs_movie_mf_id: "",
          vs_is_active: "Y",
        };

        // promotion_cinema table update
        let promo_cinema_settings = [];

        if (this.cinema_vouchers.length) {
          voucher_overall_settings["vs_screen_based"] = "Y";
          voucher_overall_settings["vs_class_based"] = "Y";
          promo_cinema_settings = this.makeUpdatePromotionVoucherArr(
            this.cinema_vouchers
          );
        } else if (this.voucher_specific_cinemas) {
          if (this.voucher_specific_cinemas.length) {
            this.voucher_specific_cinemas.forEach((cinemaObj) => {
              promo_cinema_settings.push({
                cinema_id: cinemaObj.cine_id,
                screen_id: null,
                seat_type_id: null,
                tt_id: null,
              });
            });
          }
        }
        // promotion_cinema table update

        // vouchers table update
        let vouchers = {
          voucher_title: this.voucher_name,
          voucher_receipt_name: this.voucher_receipt_print,
          is_voucher_type_value: this.voucher_config.value_voucher,
          voucher_redeem_on_net:
            this.voucher_config.voucher_redemption_on ==
            "voucherRedeemNetAmount"
              ? "Y"
              : "N",
          voucher_redeem_on_gross:
            this.voucher_config.voucher_redemption_on ==
            "voucherRedeemGrossAmount"
              ? "Y"
              : "N",
          voucher_redemption_per_patron:
            this.voucher_config.voucher_redemption_per_patron,
          voucher_total_redemption:
            this.voucher_config.voucher_total_redemption,
          voucher_start_date_time: voucherStartDate,
          voucher_end_date_time: voucherEndDate,
          voucher_start_time: this.voucher_date_time.voucher_start_time,
          voucher_end_time: this.voucher_date_time.voucher_end_time,
          voucher_description: this.vouchers_used_for,
          voucher_terms: this.voucher_terms,
          voucher_is_active: this.voucher_is_active,
          voucher_redemption_percent_fnb:
            this.voucher_config.voucher_redemption_percent_fnb || null,
          client_share_value: this.voucher_split.share_value,
          client_id: this.voucher_split.client
            ? this.voucher_split.client.client_id
            : null,
          client_share_is_percentage: this.voucher_split.share_is_percentage,
          offer_dist_share_threshold: this.offer_dist_share_threshold,
          is_web_rate_card: this.voucher_settings.is_web_rate_card,
          is_foreign_movie_applicable: this.is_foreign_movie_applicable,
          is_redemption: this.voucher_settings.is_redemptions || "N",
          voucher_is_percentage: this.voucher_config.voucher_is_percentage,
          v_reporting_percent:
            this.voucher_settings.v_reporting_percent || null,
          has_v_reporting_percent:
            this.voucher_settings.has_v_reporting_percent || "N",
        };

        if (
          this.voucher_config.value_voucher == "Y" &&
          this.voucher_settings.is_open == "N"
        ) {
          vouchers["voucher_amount"] = this.voucher_config.voucher_amount;
          vouchers["voucher_min_redemption_amount"] =
            this.voucher_config.min_ticket_amount;
          vouchers["voucher_max_redemption_amount"] =
            this.voucher_config.voucher_max_redemption_amount;
        } else if (
          this.voucher_config.value_voucher == "N" &&
          this.voucher_settings.is_open == "N"
        ) {
          if (this.voucher_config.is_bogo_voucher == "is_not_bogo_voucher") {
            vouchers["voucher_get_free_ticket"] =
              this.voucher_config.voucher_get_free_ticket;
            vouchers["voucher_min_redemption_amount"] =
              this.voucher_config.voucher_get_free_ticket;
            vouchers["voucher_type_id"] = 3;
          } else {
            vouchers["voucher_buy_no_of_ticket"] =
              this.voucher_config.voucher_buy_no_of_ticket;
            vouchers["voucher_get_free_ticket"] =
              this.voucher_config.voucher_get_free_ticket;
            vouchers["voucher_min_redemption_amount"] =
              this.voucher_config.min_ticket_amount;
            vouchers["voucher_max_redemption_amount"] =
              this.voucher_config.voucher_max_redemption_amount;
            vouchers["voucher_type_id"] = null;
          }
        }

        if (
          this.voucher_settings.is_open == "Y" &&
          this.voucher_settings.is_complimentary == "Y"
        ) {
          vouchers["is_complemetory_ticket"] =
            this.voucher_settings.is_complimentary;
          vouchers["tt_id"] = this.voucher_settings.ticket_type_selected
            ? this.voucher_settings.ticket_type_selected.tt_id
            : null;
          vouchers["cinema_id"] = this.voucher_settings.ticket_type_selected
            ? this.voucher_settings.selected_complimentary_cinema.cine_id
            : null;
          vouchers["screen_id"] = this.voucher_settings
            .selected_complimentary_screen
            ? this.voucher_settings.selected_complimentary_screen.screen_id
            : null;
        }

        if (
          this.voucher_settings.is_open == "Y" &&
          this.voucher_settings.is_complimentary == "N"
        ) {
          vouchers["is_allow_cash_refund"] =
            this.voucher_settings.allow_cash_refund;
        }

        // vouchers table update

        // promo movie update
        let promo_movie_settings = [];

        if (this.selectedMovies.length) {
          promo_movie_settings = this.selectedMovies.map(
            (filteredMoviesObj) => {
              return filteredMoviesObj;
            }
          );
          // if (promo_movie_settings.length) {
          //   promo_movie_settings.forEach((promoMovieObj) => {
          //     promoMovieObj["is_applicable"] =
          //       this.voucher_movies.is_applicable == "movies_applicable"
          //         ? "Y"
          //         : "N";
          //   });
          // }
        }
        // promo movie update

        // voucher days update
        let voucher_days = {
          pvds_id: this.currentVoucherData.vouchers.pvds_id,
          ...this.weekDays,
        };
        // voucher days update

        let meta_data = {
          vs_id: this.currentVoucherData.vouchers.vs_id,
        };

        if (this.selectedMovieFormats.length) {
          voucher_overall_settings["vs_movie_mf_id"] = this.selectedMovieFormats
            .map((mfObj) => {
              return mfObj.mf_id;
            })
            .toString();
        }

        let distShareData = [];
        if (this.distShareValues.length) {
          this.distShareValues.map((distObj) => {
            distObj.seat_type_id.map((seatObj) => {
              distShareData.push({
                sst_id: seatObj.sst_id,
                screen_id: seatObj.screen_id,
                tt_id:
                  distObj.ticket_type_id && distObj.ticket_type_id.length
                    ? distObj.ticket_type_id
                        .map((ticketObj) => {
                          return ticketObj.tt_id;
                        })
                        .toString()
                    : null,
                distValue: distObj.dist_value,
              });
            });
          });
        }

        let payload = {
          voucher_id: this.$route.params.voucher_id,
          vouchers,
          inactivePromoCinemaFields: [],
          addPromoCinemaFields: promo_cinema_settings,
          inactiveMovieFields: [],
          addPromoMovieFields: promo_movie_settings,
          is_open_voucher: this.voucher_settings.is_open,
          is_share_with_distributor: this.voucher_settings.share_with_dist,
          voucher_days,
          voucher_overall_settings,
          meta_data,
          voucher_dist_details: distShareData,
        };
        console.log({ promo_cinema_settings, payload });
        // return;

        let loader = this.$loading.show();

        const response = await MarketingService.editVouchersV2(payload);
        loader.hide();
        const { data } = response;
        if (data.status) {
          this.$router.push({
            path: "/vouchers/get-vouchers-v2",
          });
          return this.$toasted.show(data.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
.custom-date .btn-clearDate {
  right: 30px !important;
}

.customDisabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.new-border {
  border: 2px solid #b1b4b8;
}

label {
  color: black !important;
}

.internal-border-new {
  border: 1px solid #3876d2;
  /*background-color: #e6e6f8;*/
}

.internal-border {
  border: 1px solid #3876d2;
  /*background-color: #e6e6f8;*/
  display: flex;
  flex-wrap: wrap;
  border-radius: 10px;
  margin: 0 15px 15px 15px;
  padding-top: 15px;
  width: 100%;
}

.back {
  background-color: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/VouchersV2/editVouchersV2.vue